import { render, staticRenderFns } from "./BiddingSystemOld.vue?vue&type=template&id=01e5327b&"
import script from "./BiddingSystemOld.vue?vue&type=script&lang=js&"
export * from "./BiddingSystemOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports